import React from 'react';
import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { portfolioItems } from '../data/mock';
import { Helmet } from "react-helmet";


const PortfolioPage = () => {
  const breadcrumbItems = [
    { label: 'HOME', path: '/' },
    { label: 'PORTFOLIO' }
  ];

  return (
    <div className="page-wrapper">
      <PageHero 
        title="Portfolio Showcase"
        breadcrumbItems={breadcrumbItems}
        subtitle="Precision manufacturing delivered across industries"
      />
      
      <section className="page-content-section">
        <div className="container-modern">
          <div className="portfolio-page-intro">
            <p className="intro-text">
              Explore our completed projects spanning automotive, medical devices, industrial equipment, and consumer products. Each project demonstrates our commitment to precision, quality, and engineering excellence.
            </p>
          </div>
          
          <div className="portfolio-masonry">
            {portfolioItems.map((item) => (
              <div 
                key={item.id} 
                className={`portfolio-item ${item.size}`}
              >
                <div className="portfolio-image-wrapper">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="portfolio-img"
                  />
                  <div className="portfolio-overlay">
                    <div className="portfolio-content">
                      <span className="portfolio-category">{item.category}</span>
                      <h3 className="portfolio-title">{item.title}</h3>
                      <p className="portfolio-description">{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="portfolio-cta">
            <h3 className="cta-title">Have a Project in Mind?</h3>
            <p className="cta-text">
              Let's discuss how we can bring your manufacturing vision to life with precision and reliability.
            </p>
          </div>
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default PortfolioPage;
